(function () {
  'use strict';

  const grid = document.querySelector('[data-availability-sort="true"]');
  if (!grid) return;

  const collectionHandle = grid.dataset.collectionHandle;
  const productsPerPage = parseInt(grid.dataset.productsPerPage, 10);
  const currentPage = parseInt(grid.dataset.currentPage, 10) || 1;

  if (!collectionHandle || !productsPerPage) return;

  const cfg = {
    showRating: grid.dataset.showRating === 'true',
    showPixDiscount: grid.dataset.showPixDiscount === 'true',
    pixDiscountPct: parseInt(grid.dataset.pixDiscount, 10) || 0,
    showInstallments: grid.dataset.showInstallments === 'true',
    maxInstallments: parseInt(grid.dataset.maxInstallments, 10) || 1,
  };

  // ---------- helpers ----------

  // The collection products AJAX API returns `available` only at variant level,
  // not at the product level. Check variants instead.
  function isAvailable(p) {
    return (
      Array.isArray(p.variants) && p.variants.some((v) => v.available === true)
    );
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + amount;
  }

  function escHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ---------- price helpers ----------
  // The collection AJAX API returns prices as decimal strings inside variants,
  // not as price_min/compare_at_price_min at the product level.

  function getPriceCents(p) {
    const prices = (p.variants || [])
      .map((v) => Math.round(parseFloat(v.price) * 100))
      .filter((n) => !isNaN(n));
    return prices.length ? Math.min(...prices) : 0;
  }

  function getCompareAtCents(p) {
    const prices = (p.variants || [])
      .map((v) => Math.round(parseFloat(v.compare_at_price) * 100))
      .filter((n) => !isNaN(n) && n > 0);
    return prices.length ? Math.max(...prices) : 0;
  }

  function getImageSrc(p) {
    if (p.featured_image && p.featured_image.src) return p.featured_image.src;
    const imgs = p.images || [];
    return imgs.length ? imgs[0].src : '';
  }

  function getImageAlt(p) {
    if (p.featured_image && p.featured_image.alt) return p.featured_image.alt;
    const imgs = p.images || [];
    return imgs.length && imgs[0].alt ? imgs[0].alt : p.title || '';
  }

  // ---------- card builder ----------

  function buildCard(p) {
    const price = getPriceCents(p);
    const compareAt = getCompareAtCents(p);
    const hasPromo = compareAt > 0 && compareAt > price;
    const discountPct = hasPromo
      ? Math.round(((compareAt - price) * 100) / compareAt)
      : 0;

    const imgSrc = escHtml(getImageSrc(p));
    const imgAlt = escHtml(getImageAlt(p));
    const url = escHtml(p.url || '/products/' + p.handle);
    const title = escHtml(p.title || '');
    const handle = escHtml(p.handle || '');

    // tags: "Vencimento*" viram selo na base da imagem; as demais viram flag no topo
    const tags = Array.isArray(p.tags)
      ? p.tags
      : String(p.tags || '')
          .split(',')
          .map((t) => t.trim())
          .filter(Boolean);
    const expiryTags = tags.filter((t) => /vencimento/i.test(t));
    const flagTags = tags.filter((t) => !/vencimento/i.test(t));

    // flags (topo esquerdo): badge de promoção + tags que não são de vencimento
    const promoBadge = hasPromo
      ? `<span class="product-card-showcase__badge product-card-showcase__badge--promotion" aria-label="Promoção: ${discountPct}% de desconto">-${discountPct}%</span>`
      : '';
    const tagFlags = flagTags
      .map(
        (t) =>
          `<span class="product-card-showcase__tag-flag">${escHtml(t)}</span>`
      )
      .join('');
    const flags = `<div class="product-card-showcase__flags">${promoBadge}${tagFlags}</div>`;

    // selo de vencimento (base da imagem)
    const expiry = `<div class="product-card-showcase__expiry-wrap">${expiryTags
      .map(
        (t) =>
          `<span class="product-card-showcase__expiry">${escHtml(t)}</span>`
      )
      .join('')}</div>`;

    // price block
    let priceHTML = '';
    if (isAvailable(p)) {
      if (hasPromo) {
        priceHTML += `<p class="product-card-showcase__price-original" aria-hidden="true">${formatMoney(compareAt)}</p>`;
      }
      if (cfg.showPixDiscount && cfg.pixDiscountPct > 0 && hasPromo) {
        const pixPrice =
          price - Math.round((price * cfg.pixDiscountPct) / 100);
        priceHTML += `<p class="product-card-showcase__price-main product-card-showcase__price-pix">${formatMoney(pixPrice)}<span class="product-card-showcase__price-pix-text"></span></p>`;
      } else {
        priceHTML += `<p class="product-card-showcase__price-main">${formatMoney(price)}</p>`;
        if (cfg.showPixDiscount && cfg.pixDiscountPct > 0) {
          const pixPrice =
            price - Math.round((price * cfg.pixDiscountPct) / 100);
          priceHTML += `<p class="product-card-showcase__price-pix">${formatMoney(pixPrice)}<span class="product-card-showcase__price-pix-text"></span></p>`;
        }
      }
      if (cfg.showInstallments && cfg.maxInstallments > 1) {
        const inst = Math.round(price / cfg.maxInstallments);
        priceHTML += `<p class="product-card-showcase__price-installments">ou em ${cfg.maxInstallments}x de ${formatMoney(inst)}</p>`;
      }
    } else {
      priceHTML = `<p class="product-card-showcase__price-main">Esgotado</p>`;
    }

    // action button
    const action = isAvailable(p)
      ? `<a class="product-card-showcase__button product-card-showcase__button--available" href="${url}" aria-label="Comprar ${title}">Comprar Agora</a>`
      : `<button class="product-card-showcase__button product-card-showcase__button--sold-out" disabled aria-label="Esgotado">Esgotado</button>`;

    // rating placeholder (trustvox picks it up via data attribute)
    const rating = cfg.showRating
      ? `<div style="height:27px;display:block" data-trustvox-product-code="${p.id}"></div>`
      : '';

    return `<li class="grid__item" data-product-handle="${handle}"><div class="product-card-showcase"><div class="product-card-showcase__media">${flags}<a href="${url}" class="product-card-showcase__link"><img src="${imgSrc}" alt="${imgAlt}" loading="lazy" fetchpriority="low" class="product-card-showcase__image"></a>${expiry}<div class="dT_VProdWishList"><div><dtx-wishlist><a href="javascript:void(0);" class="add-wishlist button--secondary" data-product_handle="${handle}"></a></dtx-wishlist></div></div></div><div class="product-card-showcase__content"><h2 class="product-card-showcase__title"><a href="${url}" class="product-card-showcase__title-link">${title}</a></h2>${rating}<div class="product-card-showcase__price">${priceHTML}</div><div class="product-card-showcase__actions">${action}</div></div></div></li>`;
  }

  // ---------- data fetching ----------

  function getFilterSuffix() {
    const params = new URLSearchParams(window.location.search);
    const out = new URLSearchParams();
    for (const [k, v] of params.entries()) {
      if (k.startsWith('filter.') || k === 'sort_by') out.append(k, v);
    }
    const s = out.toString();
    return s ? '&' + s : '';
  }

  async function fetchAllProducts(handle) {
    const base = `/collections/${handle}/products.json`;
    const suffix = getFilterSuffix();

    const first = await fetch(`${base}?limit=250&page=1${suffix}`).then((r) =>
      r.json()
    );
    let all = first.products;

    if (all.length === 250) {
      const extras = await Promise.all(
        Array.from({ length: 7 }, (_, i) =>
          fetch(`${base}?limit=250&page=${i + 2}${suffix}`).then((r) =>
            r.json()
          )
        )
      );
      for (const d of extras) {
        all = all.concat(d.products);
        if (d.products.length < 250) break;
      }
    }

    return all;
  }

  // ---------- main ----------

  async function run() {
    try {
      const all = await fetchAllProducts(collectionHandle);
      if (!all.length) return;

      // sort: available first, preserve original relative order within each group
      const available = all.filter(isAvailable);
      const unavailable = all.filter((p) => !isAvailable(p));
      const sorted = available.concat(unavailable);

      const start = (currentPage - 1) * productsPerPage;
      const pageProd = sorted.slice(start, start + productsPerPage);
      const expectedHandles = pageProd.map((p) => p.handle);

      const renderedHandles = Array.from(
        grid.querySelectorAll('[data-product-handle]')
      ).map((el) => el.dataset.productHandle);

      // already correct — nothing to do
      if (
        expectedHandles.length === renderedHandles.length &&
        expectedHandles.every((h, i) => h === renderedHandles[i])
      )
        return;

      grid.style.opacity = '0.4';
      grid.style.pointerEvents = 'none';

      grid.innerHTML = pageProd.map(buildCard).join('');

      grid.style.opacity = '';
      grid.style.pointerEvents = '';
    } catch (err) {
      grid.style.opacity = '';
      grid.style.pointerEvents = '';
      console.warn('[availability-sort]', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
